import { styled } from '@mui/material/styles';
import { Table } from '@mui/material';

const StyledTable = styled(Table)(
  ({ theme, $columnCount }) => `
     border:  1px solid ${theme.DS_palette.border.form};
     table-layout: fixed;
     margin: ${theme.DS_spacing(['md'])} auto;
     thead {
       border-bottom:  1px solid ${theme.DS_palette.border.form};
       background-color: ${theme.DS_palette.background.lightBlue};
       text-align: left;
       vertical-align: top;  
       
      }
      th {  
        border:  1px solid ${theme.DS_palette.border.form};
        padding: ${theme.DS_spacing(['xxs'])}; 
        width: ${100 / $columnCount}%;
        
      }
      tbody > tr > td {  
        border:  1px solid ${theme.DS_palette.border.form};
        padding: ${theme.DS_spacing(['xxs'])};           
      }
       tbody > tr  {  
        vertical-align: top;        
    }
  `,
);

export { StyledTable };
